function Debuggy(view) {

    function createDiv(classe, text) {
        let div = document.createElement('div');
        div.classList.add(classe);
        if (text) {
            div.textContent = text;
        }

        return div;
    }

    

    let openclose = createDiv('openclose');
    let divArrow = createDiv('arrow-round');
    
    divArrow.innerHTML += `<svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
<style type="text/css">
   .st0{fill:#FFFFFF;}
</style>
<path class="st0" d="M28.2,23.8l-4.5-4.5l0,0c0.9-1.6,1.3-3.4,1.3-5.3c0-6.1-4.9-11-11-11S3,7.9,3,14s4.9,11,11,11
   c1.9,0,3.7-0.5,5.3-1.3l0,0l4.5,4.5c0.6,0.6,1.4,0.9,2.2,0.9s1.6-0.3,2.2-0.9C29.4,27,29.4,25,28.2,23.8z M21,15h-2.1
   c-0.1,0.6-0.4,1.2-0.7,1.8l1.5,1.5c0.4,0.4,0.4,1,0,1.4C19.5,19.9,19.3,20,19,20s-0.5-0.1-0.7-0.3l-1.5-1.5C16,18.7,15,19,14,19
   s-2-0.3-2.8-0.8l-1.5,1.5C9.5,19.9,9.3,20,9,20s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l1.5-1.5c-0.3-0.5-0.6-1.1-0.7-1.8H7
   c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.1c0.1-0.6,0.4-1.2,0.7-1.8L8.3,9.7c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l1.5,1.5
   c0.3-0.2,0.5-0.3,0.8-0.4c0-0.1,0-0.3,0-0.4c0-1.1,0.9-2,2-2s2,0.9,2,2c0,0.1,0,0.3,0,0.4c0.3,0.1,0.5,0.3,0.8,0.4l1.5-1.5
   c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-1.5,1.5c0.3,0.5,0.6,1.1,0.7,1.8H21c0.6,0,1,0.4,1,1S21.6,15,21,15z"/>
</svg>`;
    openclose.appendChild(divArrow);
    

    let telaatual = createDiv('telaatual');
    let debug = createDiv('debug');
    let pages = createDiv('pages');
    let controls = createDiv('controls');
    let title = createDiv('title', 'Flamboyant Engine');

    function makeButton(text, onclick) {
        let button = document.createElement('button');
        button.textContent = text;
        button.onclick = onclick;
        return button;
    }

    function createDebugBtns(screen, i) {
        // console.log(screen.uid, screen.parent);
        let btn = makeButton((screen.parent ? screen.parent.uid + '>' : '') + screen.uid, function () {
            view.goto(this.dataset.uid);
        });
        btn.setAttribute('data-uid', screen.uid);
        pages.appendChild(btn);
    }

    function readAllScreens(screen) {
        screen.pages.forEach((screen, i) => {
            if (screen.isCollection()) {
                readAllScreens(screen);
            } else {
                createDebugBtns(screen, i);
            }
        });
    }

    readAllScreens(view.screen);

    function clearStorage() {
        localStorage.clear();
        location.reload();
    }

    controls.appendChild(makeButton('LIMPAR DADOS', clearStorage));
    controls.appendChild(makeButton('AVANÇAR', () => view.next()));
    controls.appendChild(makeButton('VOLTAR', () => view.prev()));

    debug.appendChild(createDiv('title', 'DEBUG'));
    debug.appendChild(document.createElement('hr'));
    debug.appendChild(telaatual);
    debug.appendChild(document.createElement('hr'));
    debug.appendChild(pages);
    debug.appendChild(document.createElement('hr'));
    debug.appendChild(controls);
    debug.appendChild(document.createElement('hr'));
    debug.appendChild(title);
    debug.appendChild(openclose);

    openclose.onclick = function () {
        debug.classList.toggle('open');
    };

    $(window).on(VIEW_EVENT.LOAD_END, function (data) {
        // console.log(data.screen);
        try {
            $('.telaatual').html('Tela: ' + data.screen.model.uid);
        } catch (e) {

        }
    });

    let main = document.querySelector('body');
    main.insertBefore(debug, main.childNodes[0]);
    window.debugOn = true;
}